
import { HistoryController, SelectedApexMech, ViewType } from "@ortho-next/nextray-core";
import { Main } from "../../../nextray/Core/Main";
import { Osteotomy } from "./Osteotomy";
import { OsteotomyAP } from "./OsteotomyAP";
import { OsteotomyLT } from "./OsteotomyLT";

export class OsteotomiesManager {
	public synced = false;
	public osteotomyAP?: OsteotomyAP;
	public osteotomyLT?: OsteotomyLT;
	private _isPostOp!: boolean;

	public initBothViews(main: Main): void {
		this._isPostOp = main.isPostOp;

		main.hasAP && this.initAP(main);
		main.hasLT && this.initLT(main);
	}

	public initAP(main: Main): Osteotomy {
		this._isPostOp = main.isPostOp;
		const tools = main.toolsAP;
		if (!tools.osteotomy) {
			tools.add(tools.osteotomy = new OsteotomyAP(tools.mechanicalAxis, tools.referencePoint));
			tools.osteotomy.addEventListener('onError', () => {
				main.bridge.dispatchEvent({ type: "onResult", args: 'osteotomyLengthError' });
			});
			this.registerAP(tools.osteotomy, main.history);
		}
		return tools.osteotomy;
	}

	public initLT(main: Main): Osteotomy {
		this._isPostOp = main.isPostOp;
		const tools = main.toolsLT;
		if (!tools.osteotomy) {
			tools.add(tools.osteotomy = new OsteotomyLT(tools.mechanicalAxis, tools.referencePoint));
			tools.osteotomy.addEventListener('onError', () => {
				main.bridge.dispatchEvent({ type: "onResult", args: 'osteotomyLengthError' });
			});
			this.registerLT(tools.osteotomy, main.history);
		}
		return tools.osteotomy;
	}

	public registerAP(osteotomy: OsteotomyAP, history: HistoryController): void {
		this.osteotomyAP = osteotomy;

		// bind history
		osteotomy.bindEvent('onDragStart', () => {
			history.startTracking(ViewType.AP, osteotomy);
		});

		osteotomy.bindEvent('onDragEnd', () => {
			history.detectChanges(ViewType.AP);
		});

		this.bindSync();
	}

	public registerLT(osteotomy: OsteotomyLT, history: HistoryController): void {
		this.osteotomyLT = osteotomy;

		// bind history
		osteotomy.bindEvent('onDragStart', () => {
			history.startTracking(ViewType.LT, osteotomy);
		});

		osteotomy.bindEvent('onDragEnd', () => {
			history.detectChanges(ViewType.LT);
		});

		this.bindSync();
	}

	public bindSync(): void {
		if (this.osteotomyAP && this.osteotomyLT && !this.synced) {

			if (!this._isPostOp) {
				this.osteotomyAP.bindEvent("onAfterDragMove", () => {
					this.osteotomyLT!.distanceToReferencePoint = this.osteotomyAP!.distanceToReferencePoint;
				});

				this.osteotomyLT.bindEvent("onAfterDragMove", () => {
					this.osteotomyAP!.distanceToReferencePoint = this.osteotomyLT!.distanceToReferencePoint;
				});

				this.osteotomyAP.addEventListener('historyChanged', () => {
					this.osteotomyLT!.distanceToReferencePoint = this.osteotomyAP!.distanceToReferencePoint;
				});

				this.osteotomyLT.addEventListener('historyChanged', () => {
					this.osteotomyAP!.distanceToReferencePoint = this.osteotomyLT!.distanceToReferencePoint;
				});
			}

			this.synced = true;
		}
	}

	public setPosition(selectedApex: SelectedApexMech): void {
		this.osteotomyAP?.referencePoint.calculate(selectedApex, this.osteotomyAP.mechanicalAxis);
		this.osteotomyLT?.referencePoint.calculate(selectedApex, this.osteotomyLT.mechanicalAxis);

		this.osteotomyAP?.setPositionByApex(selectedApex);

		const osteotomyDistanceToReferencePointAP = this.osteotomyAP?.mechanicalAxis.getApexAngle(selectedApex) ? this.osteotomyAP!.distanceToReferencePoint : undefined;
		this.osteotomyLT?.setPositionByApex(selectedApex, osteotomyDistanceToReferencePointAP!);

		if (osteotomyDistanceToReferencePointAP === undefined && this.osteotomyAP && this.osteotomyLT) {
			this.osteotomyAP.distanceToReferencePoint = this.osteotomyLT.distanceToReferencePoint;
		}
	}
}
